var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOauthLogoGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37423 0 0 5.50943 0 12.3019C0 17.7358 3.46012 22.3396 8.17178 24C8.76074 24.0755 8.9816 23.6981 8.9816 23.3962C8.9816 23.0943 8.9816 22.3396 8.9816 21.283C5.66871 22.0377 4.93252 19.6226 4.93252 19.6226C4.41718 18.1887 3.60736 17.8113 3.60736 17.8113C2.50307 17.0566 3.68098 17.0566 3.68098 17.0566C4.8589 17.1321 5.52147 18.3396 5.52147 18.3396C6.62577 20.2264 8.31902 19.6981 8.9816 19.3962C9.05522 18.566 9.42331 18.0377 9.71779 17.7359C7.06749 17.434 4.26994 16.3774 4.26994 11.6226C4.26994 10.2642 4.71166 9.20755 5.52147 8.30189C5.44785 8.07547 5.00614 6.79245 5.66871 5.13208C5.66871 5.13208 6.69939 4.83019 8.9816 6.41509C9.93865 6.11321 10.9693 6.03774 12 6.03774C13.0307 6.03774 14.0614 6.18868 15.0184 6.41509C17.3006 4.83019 18.3313 5.13208 18.3313 5.13208C18.9939 6.79245 18.5521 8.07547 18.4785 8.37736C19.2147 9.20755 19.7301 10.3396 19.7301 11.6981C19.7301 16.4528 16.9325 17.434 14.2822 17.7359C14.7239 18.1132 15.092 18.8679 15.092 20C15.092 21.6604 15.092 22.9434 15.092 23.3962C15.092 23.6981 15.3129 24.0755 15.9018 24C20.6871 22.3396 24.0736 17.7358 24.0736 12.3019C24 5.50943 18.6258 0 12 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOauthLogoGithub);
export default __webpack_public_path__ + "static/media/oauth-logo-github.8844bd5d00af6b41405ac9762ac0103a.svg";
export { ForwardRef as ReactComponent };